import { GlobalFilter } from '@hotjar/global-filters';
import { updateFilterAndUrl } from './updateFilterAndUrl';
import { openList } from './toggleRecordingsView';

import type { Store } from '../../../store/list/types';

export const handleFilterChange = (
  store: Store,
  filtersInUiFormat: GlobalFilter,
  isInOverviewExperiment: boolean,
  enableFilterInteraction: () => void,
  optionalSegmentId?: number,
): void => {
  // This wrapper function is a part of recommened recordings experiment.
  // It takes care of changing the view to the list when the filter is changed.
  updateFilterAndUrl(store, filtersInUiFormat, optionalSegmentId);

  // If the user is not in the experiment, we proceed as we used to with list-only view.
  if (!isInOverviewExperiment) {
    return;
  }

  // We explicitly add a view param to the list to indicate the view change.
  // We let the experiment hook now that the filters have been applied.
  openList(enableFilterInteraction);
};
